import AsyncStorage from '@react-native-async-storage/async-storage'
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface PointsToOmniState {
  selectedPartner: 'OMNI' | null
  selectedGuestId: string | null
  mesaPointsToRedeem: number | null
  partnerCredits: number | null
  idempotencyKey: string | null
  conversionRate: number | null
  remainingPoints: number | null
}

interface PointsToOmniActions {
  setSelectedPartner: (partner: 'OMNI' | null) => void
  setSelectedGuestId: (guestId: string | null) => void
  setMesaPointsToRedeem: (points: number | null) => void
  setPartnerCredits: (credits: number | null) => void
  setIdempotencyKey: (key: string | null) => void
  setConversionRate: (rate: number | null) => void
  setRemainingPoints: (points: number | null) => void
  clear: () => void
  clearAll: () => void
}

type PointsToOmniStore = PointsToOmniState & PointsToOmniActions

const initialState: PointsToOmniState = {
  selectedPartner: null,
  selectedGuestId: null,
  mesaPointsToRedeem: null,
  partnerCredits: null,
  idempotencyKey: null,
  conversionRate: null,
  remainingPoints: null,
}

export const usePointsToOmniStore = create<PointsToOmniStore>()(
  // storing in zustand for now to remember the omni ID. Not sure if we want to store
  // this on the BE yet. Can always migrate with point transfer events
  persist(
    (set) => ({
      ...initialState,
      setSelectedPartner: (selectedPartner) => set({ selectedPartner }),
      setSelectedGuestId: (selectedGuestId) => set({ selectedGuestId }),
      setMesaPointsToRedeem: (mesaPointsToRedeem) => set({ mesaPointsToRedeem }),
      setPartnerCredits: (partnerCredits) => set({ partnerCredits }),
      setIdempotencyKey: (idempotencyKey) => set({ idempotencyKey }),
      setConversionRate: (conversionRate) => set({ conversionRate }),
      setRemainingPoints: (remainingPoints) => set({ remainingPoints }),
      clear: () => set((state) => ({ ...initialState, selectedGuestId: state.selectedGuestId })),
      clearAll: () => set(initialState),
    }),
    {
      name: 'points-to-omni-storage',
      storage: createJSONStorage(() => AsyncStorage),
      partialize: (state) => ({
        selectedGuestId: state.selectedGuestId,
      }),
    },
  ),
)
